import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  Menu, X, ChevronDown, Globe, ArrowRight,
  ShoppingBag, Repeat2, Megaphone, Wallet, Globe2, Percent,
  BedDouble, Users, MessageSquareHeart, Smartphone, ScanLine, Building2,
  BarChart3, LineChart, Brain, Bot,
  GraduationCap, KeyRound, FileText, Calendar,
  Hotel, Home, UtensilsCrossed, Building, Tent,
  Briefcase, Ticket, Network, ShieldCheck, Cog,
} from "lucide-react";
import { useI18n, useLangPath } from "@/contexts/I18nContext";
import LanguageSelector from "@/components/LanguageSelector";

/* ─── Mega-menu data ─── */
const SIDEBAR = [
  { key: "hotele",      label: "Hotele" },
  { key: "apartamente", label: "Apartamente" },
];

/* "Zgjidhje" mega-menu — 2 column layout */
const SOLUTIONS = {
  prona: {
    title: "Prona",
    items: [
      { icon: Hotel,             label: "Hotele",                to: "/platforma" },
      { icon: Home,              label: "Apartamente me Qera",   to: "/platforma" },
      { icon: UtensilsCrossed,   label: "Bujtina & Vila",        to: "/platforma" },
      { icon: Building,          label: "Grupe Hotelesh",        to: "/platforma" },
      { icon: Tent,              label: "Hostele",               to: "/platforma" },
    ],
  },
  partnere: {
    title: "Partnerë",
    items: [
      { icon: Briefcase,   label: "Agjenci Udhëtimi",    to: "/integrimet" },
      { icon: Ticket,      label: "Tour Operatorë",      to: "/integrimet" },
      { icon: Network,     label: "Channel Partnerë",    to: "/integrimet" },
      { icon: ShieldCheck, label: "Sisteme Pagese",      to: "/integrimet" },
      { icon: Building2,   label: "Smart Hotel Systems", to: "/integrimet" },
      { icon: Cog,         label: "Integrime API",       to: "/integrimet" },
    ],
  },
};

/* For each sidebar category, define 4 columns of features */
const MENU = {
  hotele: [
    {
      title: "Shitje & Marketing",
      items: [
        { icon: ShoppingBag, label: "Booking Engine",   to: "/booking-engine",   hint: "Rezervime direkte në website" },
        { icon: Repeat2,     label: "Channel Manager",  to: "/channel-manager",  hint: "Booking · Airbnb · Expedia" },
        { icon: Megaphone,   label: "Promocione",       to: "/platforma",        hint: "Oferta dhe paketa stinore" },
        { icon: Wallet,      label: "Pagesa Online",    to: "/integrimet",       hint: "Stripe, kartë, e-banking" },
        { icon: Globe2,      label: "Website Hoteli",   to: "/platforma",        hint: "Site i shpejtë, gati për SEO" },
        { icon: Percent,     label: "Çmime dinamike",   to: "/platforma",        hint: "Çmime që ndjekin kërkesën" },
      ],
    },
    {
      title: "Klientë & Operacione",
      items: [
        { icon: BedDouble,           label: "PMS",                  to: "/pms",          hint: "Rezervimet & recepsioni" },
        { icon: Users,               label: "CRM i Klientit",       to: "/platforma",    hint: "Profilet dhe komunikimi" },
        { icon: MessageSquareHeart,  label: "Komente & Vlerësime",  to: "/platforma",    hint: "Të gjitha review-t në një vend", badge: "AI" },
        { icon: Smartphone,          label: "Online Check-In",      to: "/platforma",    hint: "Check-in nga celulari" },
        { icon: ScanLine,            label: "Skanim Dokumentesh",   to: "/platforma",    hint: "Identifikim i automatizuar" },
        { icon: Building2,           label: "Smart Hotel",          to: "/integrimet",   hint: "IoT, çelësa elektronikë" },
      ],
    },
    {
      title: "Automatizim & AI",
      items: [
        { icon: BarChart3, label: "Analitika & Raporte",   to: "/platforma",  hint: "ADR · RevPAR · zënia" },
        { icon: LineChart, label: "Analiza e Konkurrencës", to: "/platforma",  hint: "Çmimet e tregut në kohë reale" },
        { icon: Brain,     label: "Business Intelligence",  to: "/platforma",  hint: "Insight-e të thelluara" },
        { icon: Bot,       label: "Autopilot për Çmime",    to: "/platforma",  hint: "Çmime automatike", badge: "AI" },
      ],
    },
    {
      title: "Konsulencë e Dedikuar",
      items: [
        { icon: GraduationCap, label: "Akomoda Elite",       to: "/kontakt", hint: "Trajnim & mbështetje personale" },
      ],
    },
  ],
  apartamente: [
    {
      title: "Shitje & Marketing",
      items: [
        { icon: ShoppingBag, label: "Booking Engine",   to: "/booking-engine",  hint: "Rezervime direkte për apartamente" },
        { icon: Repeat2,     label: "Channel Manager",  to: "/channel-manager", hint: "Airbnb, Booking, Vrbo" },
        { icon: Wallet,      label: "Pagesa Online",    to: "/integrimet",      hint: "Stripe & karta" },
        { icon: Globe2,      label: "Faqe Promovimi",   to: "/platforma",       hint: "Faqe e gatshme për pronën" },
      ],
    },
    {
      title: "Klientë & Operacione",
      items: [
        { icon: BedDouble,    label: "Menaxhim Rezervimesh", to: "/pms",        hint: "Kalendari multi-pronë" },
        { icon: KeyRound,     label: "Çelësa Elektronikë",   to: "/integrimet", hint: "Smart-lock & PIN-kode" },
        { icon: Smartphone,   label: "Online Check-In",      to: "/platforma",  hint: "Klienti hyn pa recepsion" },
        { icon: FileText,     label: "Kontrata Auto-Sign",   to: "/platforma",  hint: "Nënshkrim elektronik" },
      ],
    },
    {
      title: "Automatizim & AI",
      items: [
        { icon: BarChart3, label: "Raporte Performance", to: "/platforma", hint: "Të ardhura për pronë" },
        { icon: Bot,       label: "Mesazhe Automatike",  to: "/platforma", hint: "Nga rezervimi te check-out", badge: "AI" },
        { icon: Calendar,  label: "Sinkron Multi-Listing", to: "/platforma", hint: "Të gjitha pronat në një vend" },
      ],
    },
    {
      title: "Konsulencë e Dedikuar",
      items: [
        { icon: GraduationCap, label: "Akomoda Elite", to: "/kontakt", hint: "Konsulencë për pronarë" },
      ],
    },
  ],
};

export default function Header() {
  const [open, setOpen] = useState(false);
  const [platformOpen, setPlatformOpen] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [activeSidebar, setActiveSidebar] = useState("hotele");
  const [scrolled, setScrolled] = useState(false);
  const { lang, setLang, t } = useI18n();
  const withLang = useLangPath();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const columns = MENU[activeSidebar];

  return (
    <header
      className={`sticky top-0 z-40 border-b transition-colors duration-200 ${scrolled ? "border-[#E2E8F0] bg-white/95 backdrop-blur-sm" : "border-transparent bg-white"}`}
      data-testid="site-header"
    >
      <div className="container-akm flex h-[68px] items-center justify-between">
        <Link to={withLang("/")} className="flex items-center" data-testid="logo-link">
          <img src="/akomoda-logo-dark.png" alt="Akomoda" className="h-8 w-auto md:h-9" width="160" height="36" />
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label={t.nav.mainNav}>
          <div
            className="relative"
            onMouseEnter={() => setPlatformOpen(true)}
            onMouseLeave={() => setPlatformOpen(false)}
          >
            <button type="button" className="flex items-center gap-1 rounded-md px-3 py-2 text-[14px] font-medium text-[#334155] hover:text-[#0F172A]" data-testid="nav-platform-toggle">
              {t.nav.platform} <ChevronDown size={14} className={`transition-transform ${platformOpen ? "rotate-180" : ""}`} />
            </button>
            {platformOpen && (
              <div
                className="fixed left-1/2 top-[68px] z-50 w-[min(96vw,1100px)] -translate-x-1/2 pt-2"
                data-testid="nav-platform-menu"
              >
                <div className="overflow-hidden rounded-2xl border border-[#E2E8F0] bg-white shadow-[0_30px_80px_-30px_rgba(11,18,32,0.35)]">
                  <div className="grid grid-cols-[200px_1fr]">
                    {/* ─── Sidebar ─── */}
                    <aside className="border-r border-[#F1F5F9] bg-[#FAFBFC] p-3">
                      <ul className="space-y-1">
                        {SIDEBAR.map((s) => (
                          <li key={s.key}>
                            <button
                              type="button"
                              onMouseEnter={() => setActiveSidebar(s.key)}
                              onFocus={() => setActiveSidebar(s.key)}
                              className={`flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-left text-[13.5px] font-semibold transition-colors ${
                                activeSidebar === s.key
                                  ? "bg-[#FFF1E5] text-[#EA580C]"
                                  : "text-[#0F172A] hover:bg-white"
                              }`}
                              data-testid={`nav-platform-side-${s.key}`}
                            >
                              {s.label}
                              <ArrowRight size={13} className={activeSidebar === s.key ? "text-[#EA580C]" : "text-[#94A3B8]"} />
                            </button>
                          </li>
                        ))}
                      </ul>
                    </aside>

                    {/* ─── Columns ─── */}
                    <div className="grid grid-cols-2 gap-x-8 gap-y-10 px-8 py-8 lg:grid-cols-4">
                      {columns.map((col) => (
                        <div key={col.title}>
                          <h3 className="text-[10.5px] font-semibold uppercase tracking-[0.18em] text-[#94A3B8]">
                            {col.title}
                          </h3>
                          <ul className="mt-5 space-y-4">
                            {col.items.map((it) => (
                              <li key={it.label}>
                                <Link
                                  to={withLang(it.to)}
                                  onClick={() => setPlatformOpen(false)}
                                  className="group flex items-center gap-3 text-[#0F172A] hover:text-[#EA580C]"
                                >
                                  <span className="grid h-7 w-7 shrink-0 place-items-center text-[#64748B] transition-colors group-hover:text-[#EA580C]">
                                    <it.icon size={18} strokeWidth={1.6} />
                                  </span>
                                  <span className="inline-flex items-center gap-2 text-[14px] font-medium leading-tight">
                                    {it.label}
                                    {it.badge && (
                                      <span className="rounded-full bg-gradient-to-br from-[#A855F7] to-[#7C3AED] px-1.5 py-[2px] text-[8.5px] font-bold uppercase tracking-wider text-white">
                                        {it.badge}
                                      </span>
                                    )}
                                  </span>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Bottom CTA strip */}
                  <div className="flex items-center justify-between border-t border-[#F1F5F9] bg-[#FAFBFC] px-6 py-3">
                    <div>
                      <div className="text-[12.5px] font-semibold text-[#0F172A]">Shihni Akomoda në veprim</div>
                      <div className="text-[11px] text-[#64748B]">Demo falas — 30 minuta</div>
                    </div>
                    <Link
                      to="/demo"
                      onClick={() => setPlatformOpen(false)}
                      className="inline-flex items-center gap-2 rounded-full bg-[#FF7A00] px-4 py-2 text-[12px] font-semibold text-white hover:bg-[#EA580C]"
                    >
                      Kërko Demo <ArrowRight size={12} />
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ─── Zgjidhje dropdown ─── */}
          <div
            className="relative"
            onMouseEnter={() => setSolutionsOpen(true)}
            onMouseLeave={() => setSolutionsOpen(false)}
          >
            <button
              type="button"
              className={`flex items-center gap-1 rounded-md px-3 py-2 text-[14px] font-medium ${solutionsOpen ? "text-[#0F172A]" : "text-[#334155] hover:text-[#0F172A]"}`}
              data-testid="nav-solutions-toggle"
            >
              {t.nav.solutions}
              <ChevronDown size={14} className={`transition-transform ${solutionsOpen ? "rotate-180" : ""}`} />
            </button>
            {solutionsOpen && (
              <>
                {/* Orange underline accent like reference */}
                <span
                  className="pointer-events-none absolute left-3 right-3 -bottom-px h-[2px] rounded-full bg-[#FF7A00]"
                  aria-hidden
                />
                <div
                  className="fixed left-1/2 top-[68px] z-50 w-[min(96vw,720px)] -translate-x-1/2 pt-2"
                  data-testid="nav-solutions-menu"
                >
                  <div className="overflow-hidden rounded-2xl border border-[#E2E8F0] bg-white shadow-[0_30px_80px_-30px_rgba(11,18,32,0.35)]">
                    <div className="grid grid-cols-1 gap-x-10 gap-y-8 px-8 py-8 md:grid-cols-2">
                      {[SOLUTIONS.prona, SOLUTIONS.partnere].map((group) => (
                        <div key={group.title}>
                          <h3 className="text-[10.5px] font-semibold uppercase tracking-[0.18em] text-[#94A3B8]">
                            {group.title}
                          </h3>
                          <ul className="mt-5 space-y-4">
                            {group.items.map((it) => (
                              <li key={it.label}>
                                <Link
                                  to={withLang(it.to)}
                                  onClick={() => setSolutionsOpen(false)}
                                  className="group flex items-center gap-3 text-[#0F172A] hover:text-[#EA580C]"
                                >
                                  <span className="grid h-7 w-7 shrink-0 place-items-center text-[#64748B] transition-colors group-hover:text-[#EA580C]">
                                    <it.icon size={18} strokeWidth={1.6} />
                                  </span>
                                  <span className="text-[14px] font-medium leading-tight">
                                    {it.label}
                                  </span>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <NavLink to={withLang("/cmimet")} className={({ isActive }) => `rounded-md px-3 py-2 text-[14px] font-medium hover:text-[#0F172A] ${isActive ? "text-[#EA580C]" : "text-[#334155]"}`} data-testid="nav-cmimet">{t.nav.pricing}</NavLink>
          <NavLink to={withLang("/integrimet")} className={({ isActive }) => `rounded-md px-3 py-2 text-[14px] font-medium hover:text-[#0F172A] ${isActive ? "text-[#EA580C]" : "text-[#334155]"}`}>{t.nav.integrations}</NavLink>
          <NavLink to={withLang("/rreth-nesh")} className={({ isActive }) => `rounded-md px-3 py-2 text-[14px] font-medium hover:text-[#0F172A] ${isActive ? "text-[#EA580C]" : "text-[#334155]"}`} data-testid="nav-rreth-nesh">{t.nav.about}</NavLink>
          <NavLink to={withLang("/blog")} className={({ isActive }) => `rounded-md px-3 py-2 text-[14px] font-medium hover:text-[#0F172A] ${isActive ? "text-[#EA580C]" : "text-[#334155]"}`} data-testid="nav-blog">{t.nav.blog}</NavLink>
          <NavLink to={withLang("/kontakt")} className={({ isActive }) => `rounded-md px-3 py-2 text-[14px] font-medium hover:text-[#0F172A] ${isActive ? "text-[#EA580C]" : "text-[#334155]"}`} data-testid="nav-kontakt">{t.nav.contact}</NavLink>
        </nav>

        <div className="hidden items-center gap-2 lg:flex">
          <LanguageSelector />
          <Link to={withLang("/demo")} className="btn-primary !py-2.5" data-testid="nav-demo-cta">{t.nav.requestDemo} <ArrowRight size={14} /></Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="grid h-10 w-10 place-items-center rounded-md border border-[#E2E8F0] bg-white lg:hidden"
          aria-label={t.nav.openMenu}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#E2E8F0] bg-white lg:hidden" data-testid="mobile-menu">
          <div className="container-akm flex flex-col gap-1 py-3">
            <div className="px-3 py-2 text-[11px] font-semibold uppercase tracking-wider text-[#64748B]">{t.nav.platform}</div>
            {MENU[activeSidebar].flatMap((col) => col.items).slice(0, 8).map((l) => (
              <Link key={l.to + l.label} to={withLang(l.to)} onClick={() => setOpen(false)} className="rounded-md px-3 py-2 text-[14px] text-[#0F172A] hover:bg-[#F8FAFC]">
                {l.label}
              </Link>
            ))}
            <div className="my-2 h-px bg-[#E2E8F0]" />
            <Link to={withLang("/cmimet")} onClick={() => setOpen(false)} className="rounded-md px-3 py-2 text-[14px] text-[#0F172A]">{t.nav.pricing}</Link>
            <Link to={withLang("/rreth-nesh")} onClick={() => setOpen(false)} className="rounded-md px-3 py-2 text-[14px] text-[#0F172A]">{t.nav.about}</Link>
            <Link to={withLang("/blog")} onClick={() => setOpen(false)} className="rounded-md px-3 py-2 text-[14px] text-[#0F172A]">{t.nav.blog}</Link>
            <Link to={withLang("/kontakt")} onClick={() => setOpen(false)} className="rounded-md px-3 py-2 text-[14px] text-[#0F172A]">{t.nav.contact}</Link>
            <div className="mt-2 self-start">
              <LanguageSelector />
            </div>
            <Link to={withLang("/demo")} onClick={() => setOpen(false)} className="btn-primary mt-2 justify-center">{t.nav.requestDemo}</Link>
          </div>
        </div>
      )}
    </header>
  );
}
